module.exports = __webpack_public_path__ + "img/structured_data_cv.63aebc40.jpg";